var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"footer"},[_vm._v("Copyright © 学说 I 京ICP备20020497号-1")])])
}]

export { render, staticRenderFns }